var map = {
	"./ABC.svg": 64274,
	"./EUROSKLEP.svg": 45782,
	"./EURO_SKLEP.svg": 62005,
	"./GROSZEK.svg": 99695,
	"./M_SKLEPY.png": 58362,
	"./drs/application-device.svg": 10663,
	"./drs/arrow.svg": 10141,
	"./drs/bag-all.svg": 29170,
	"./drs/bag-glass.svg": 67395,
	"./drs/bag-metal.svg": 83378,
	"./drs/bag-mix.svg": 7729,
	"./drs/bag-plastic.svg": 59063,
	"./drs/bank.svg": 12580,
	"./drs/blik.svg": 24564,
	"./drs/cash-device.svg": 27550,
	"./drs/cash.svg": 92687,
	"./drs/collections.svg": 9969,
	"./drs/credit-card.svg": 76084,
	"./drs/europlatform.svg": 19252,
	"./drs/glass-bag.svg": 76775,
	"./drs/glass.svg": 14562,
	"./drs/kaucyjni.svg": 43768,
	"./drs/location-mapping.svg": 15966,
	"./drs/mastercard.svg": 36538,
	"./drs/metal-bag.svg": 53774,
	"./drs/metal.svg": 883,
	"./drs/mix-bag.svg": 25073,
	"./drs/mix.svg": 24236,
	"./drs/mobile.svg": 66676,
	"./drs/operators.svg": 15089,
	"./drs/panel-device.svg": 63479,
	"./drs/plastic-bag-full.svg": 14407,
	"./drs/plastic-bag.svg": 35919,
	"./drs/plastic.svg": 78458,
	"./drs/przelewy24.svg": 62532,
	"./drs/reports.svg": 43179,
	"./drs/rvm-device.svg": 9798,
	"./drs/settings.svg": 48181,
	"./drs/stores.svg": 36496,
	"./drs/tutorial-mobile.svg": 49143,
	"./drs/tutorial.svg": 4196,
	"./drs/visa.svg": 20605,
	"./labels-thank-you.svg": 29358,
	"./login.svg": 5253,
	"./my-business/advertising-materials.svg": 21917,
	"./my-business/agreement-template.svg": 29441,
	"./my-business/announcements.svg": 7646,
	"./my-business/contract-template-operational-manual.svg": 59499,
	"./my-business/drs.svg": 17711,
	"./my-business/loan.svg": 73712,
	"./my-business/newspaper-materials.svg": 14194,
	"./my-business/operations-manual.svg": 49571,
	"./my-business/partners-council.svg": 35325,
	"./my-business/purchasing-group-equal-in-business.svg": 17716,
	"./my-business/retr.svg": 84031,
	"./my-business/retrodiscounts-services-manual.svg": 86750,
	"./my-business/terms-of-business.svg": 37042,
	"./notifications.svg": 95074,
	"./promo-adv.png": 5583,
	"./reports/service-2.svg": 51822,
	"./services/service-1.svg": 28736,
	"./services/service-2.svg": 19475,
	"./services/service-3.svg": 5250,
	"./services/service-4.svg": 14541,
	"./welcome-ep.jpg": 60898,
	"./welcome-mpromo.jpg": 1963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;